import { PropsWithChildren } from 'react';
import ReactDraggable from 'react-draggable';
import { DEFAULT_DRAGGABLE_BOUNDS, DEFAULT_DRAGGABLE_POSITION } from 'consts/draggable';
import DraggableProps from './Draggable.types';

const Draggable = ({
  children,
  onPositionChange,
  onDragStart,
  onDragStop,
  grid,
  scale,
  className = '',
  axis = 'both',
  draggedElementPosition = DEFAULT_DRAGGABLE_POSITION,
  containerBounds = DEFAULT_DRAGGABLE_BOUNDS,
}: PropsWithChildren<DraggableProps>): React.ReactElement => {
  const handlePositionChange: DraggableProps['onPositionChange'] = (event, data) => {
    onPositionChange?.(event, {
      ...data,
      x: axis === 'y' ? (draggedElementPosition?.x ?? 0) : data.x,
      y: axis === 'x' ? (draggedElementPosition?.y ?? 0) : data.y,
    });
  };

  return (
    <ReactDraggable
      defaultClassName={className}
      axis={axis}
      grid={grid}
      scale={scale}
      position={draggedElementPosition}
      bounds={containerBounds}
      onDrag={handlePositionChange}
      onStart={onDragStart}
      onStop={onDragStop}
    >
      {children}
    </ReactDraggable>
  );
};

export default Draggable;
